import { useEffect } from "react";
import {
  callAPIInterface,
  generateAmountToPass,
} from "../components/constants";

function useCouponCodes({
  amount,
  data,
  swapInAsset,
  currency,
  session,
  showFeesSection,
  queryParam,
  appliedCoupon,
  module = "SEND",
  showCouponCodes,
  setCouponCodes,
  setAppliedCoupon,
  setButtonLoader,
  setNetworkFeeLoader,
}) {
  const getCouponCodes = async () => {
    const finalAmount = generateAmountToPass(amount, currency);

    const couponPostData = {
      avail_on: module,
      amount: Number(finalAmount) || 0,
      asset_id: currency,
      ...(module === "SWAP"
        ? { swap_in_asset: swapInAsset }
        : { withdraw_request: data?.withdraw_request }),
    };

    try {
      const res = await callAPIInterface(
        "POST",
        `/promo-code/list?${queryParam}`,
        JSON.stringify(couponPostData)
      );
      setCouponCodes(res?.data);
      if (appliedCoupon) {
        const isAppliedCouponEligible = res?.data.find(
          (couponCode) => couponCode?.id === appliedCoupon.id
        )?.is_eligible;
        if (!isAppliedCouponEligible) setAppliedCoupon(null);
      }
    } catch (error) {
      setCouponCodes([]);
      setAppliedCoupon(null);
    } finally {
      setButtonLoader(false);
    }
  };

  const validateCoupon = async (couponCode) => {
    setNetworkFeeLoader(true);

    const finalAmount = generateAmountToPass(amount, currency);

    const apiData = {
      name: couponCode?.name,
      avail_on: module,
      amount: Number(finalAmount),
      asset_id: couponCode?.asset_id,
      ...(module === "SWAP"
        ? { swap_in_asset: swapInAsset }
        : { withdraw_request: data?.withdraw_request }),
    };

    const res = await callAPIInterface("POST", "/promo-code/validate", apiData);
    setNetworkFeeLoader(false);
    return res?.is_valid;
  };

  useEffect(() => {
    if (session) {
      const couponDebounce = setTimeout(() => {
        if (showCouponCodes) {
          setButtonLoader(true);
          getCouponCodes();
        } else {
          setCouponCodes([]);
          setAppliedCoupon(null);
          setButtonLoader(false);
        }
      }, 500);

      return () => clearTimeout(couponDebounce);
    }
  }, [session, amount, data, currency, showFeesSection]);

  return { validateCoupon };
}

export default useCouponCodes;
